import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class QuestionService extends Service{
    constructor() {
        super();
        this.baseURL = 'question';
    }

    findByExamId(examId) {
        return fetch(SERVER_URL + this.baseURL + '/findByExamId/' + examId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}